export default "__VITE_ASSET__C$vG$kZ1__"